/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

/** The first status poll comes after this long; each next one waits longer, up to the maximum. */
export const INITIAL_POLL_DELAY_MS = 2000;
export const MAX_POLL_DELAY_MS = 5000;
export const POLL_BACKOFF_FACTOR = 1.5;

/** How long to wait before poll number {@code attempt} (0 is the first): 2 s, 3 s, 4.5 s, then 5 s. */
export const pollDelayMs = (attempt: number): number =>
  Math.min(MAX_POLL_DELAY_MS, Math.round(INITIAL_POLL_DELAY_MS * POLL_BACKOFF_FACTOR ** attempt));

/** The `reason` of the 409 the server answers when a re-evaluation of the repository is already running. */
export const ALREADY_RUNNING_REASON = 'REEVALUATION_ALREADY_RUNNING';

export const RE_EVALUATE_CLICKED_EVENT = 'evaluations_re_evaluate_clicked';
